import { useState } from 'react';
import { recomendations } from '../controllers/entities';
import { CommonEntity, Query, Result } from '../interfaces';
import { CommonsEntityAdapter } from '../adapter/entities-adapter';
import { Adapter } from '../shared/adapter';

const initialState: Result<CommonEntity> = {
    loading: false,
    values: []
};

export default function useRecomendations() {
    const [result, setResult] = useState<Result<CommonEntity>>(initialState);

    const getRecomendations = async (collection: string, query: Query, page?: number, limit?: number) => {
        try {
            setResult((prevResult) => ({ ...prevResult, loading: true }));
            const response = await recomendations(collection || 'all', query, page, limit);
            setResult({
                values: Adapter.from(response.items).to((value) => new CommonsEntityAdapter(value).adapt()),
                loading: false,
                pagination: {
                    limit,
                    page,
                    total: response.meta.total
                }
            });
        } catch (error) {
            setResult((prevResult) => ({ ...prevResult, loading: false }));
        }
    }

    return {
        result,
        getRecomendations
    }
}
